<template>
    <MainContentSearchable
        :title="'Precios ' + (teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Terrenos' : 'Parcelas')" 
        id="parcelas" 
        v-model="filters" 
        :meta="loading ? {} : preciosParcelas.meta"
        :disabled="loading" 
        @updated="debouncedGetParcelas"
    >
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de precios {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Terrenos' : 'Parcelas' }}</h3>
            <div class="card-tools mb-3">
                <Button 
                    class="btn btn-primary"
                    @click="showModal('crear-parcela')"
                >
                    CREAR PRECIO  
                </Button>
            </div>
        </template>

        <template v-slot:content>
            <ContainerTable :data="preciosParcelas.data || []" :responsive="esMovil">
                <b-table 
                    hover 
                    :items="preciosParcelas.data || []" 
                    :fields="fields" 
                    :busy="loading" 
                    :empty-text="'No hay ' + (teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? 'Terrenos' : 'Parcelas') + ' registradas'"
                >
                    <template #cell(precio)="{ item }">
                        {{ item.precio | formatear_precio }}
                    </template>
                    
                    <template #cell(start_date)="{ item }">
                        {{ item.start_date }}
                    </template>
                    
                    <template #cell(end_date)="{ item }">
                        {{ item.end_date }}
                    </template>
                    
                    <template #cell(acciones)="{ item, index }">
                        <OpcionesDropdownTableComponent
                            :lastIndex="(preciosParcelas.data || []).length > 3 && index >= (preciosParcelas.data || []).length - 3"
                            :options="[
                                { to: { name: 'back.precios.parcelas.show', params: { precio_id: item.id, lista_id: listaId }}, label: 'Ver'},
                                { type: 'action', action: () => editarParcela(item), label: 'Editar'},
                                { type: 'action', action: () => showModal('borrar-' + item.id), label: 'Borrar' },
                            ]"
                        />
                        <BorrarModalComponent
                            confirmButton="¿Está segur@ de borrar este precio?"
                            :name="'borrar-' + item.id"
                            :title="'Borrar precio de ' + item.description"
                            @close="() => closeModal('borrar-' + item.id, false)"
                            @confirm="() => eliminarParcela(item.id)"
                        />
                        <ModalComponent
                            :name="'editar-' + item.id"
                            :title="'Editar precio de ' + item.description"
                            @close="() => closeModal('editar-' + item.id, false)"
                            @opened="() => cargarDatosParcela(item.id)"
                        >
                            <div v-if="cargando" class="text-center p-3">
                                <b-spinner variant="primary" label="Cargando..."/>
                            </div>
                            <FormPrecioParcelas 
                                v-else
                                :parcela="parcelaEditando"
                                :loading="guardando"
                                @terminado="guardarCambios"
                            />
                        </ModalComponent>
                    </template>
                </b-table>
            </ContainerTable>
            <ModalComponent
                name="crear-parcela"
                title="Crear nuevo precio"
                @close="() => closeModal('crear-parcela', false)"
            >
                <FormPrecioParcelas 
                    :parcela="{}"
                    :loading="creando"
                    @terminado="crearParcela"
                />
            </ModalComponent>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import FormPrecioParcelas from '@/components/backend/parcelas/FormPrecioParcelas.vue';
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';
    import Button from '@/components/common/Button';
    import debounce from 'lodash/debounce';

    export default {
        name: 'ListadoPrecios',
        components: {
            MainContentSearchable, ContainerTable, BorrarModalComponent, OpcionesDropdownTableComponent, ModalComponent, FormPrecioParcelas, Button
        },
        data() {
            return {
                loading: false,
                fields: [
                    { key: "description", label: "Descripción" },
                    { key: "precio", label: "Precio", class: "text-center" },
                    { key: "start_date", label: "Fecha Inicio", class: "text-center" },
                    { key: "end_date", label: "Fecha Fin", class: "text-center" },
                    { key: "acciones", label: "Acciones", class: "text-center" }
                ],
                filters: {
                    search: '',
                    per_page: 10,
                    page: 1
                },
                preciosParcelas: {
                    data: [],
                    meta: {
                        current_page: 1,
                        per_page: 10,
                        total: 0
                    }
                },
                parcelaEditando: null,
                cargando: false,
                guardando: false,
                creando: false
            }
        },
        async created() {
            this.getParcelas();
            this.debouncedGetParcelas = debounce(this.getParcelas, 500);
        },
        methods: {
            async getParcelas() {
                try {
                    this.loading = true;

                    if (!this.filters.search) {
                        delete this.filters.search;
                    }
                    
                    const response = await this.$store.dispatch('BACK_PRECIOS_PARCELAS', {
                        lista_id: this.listaId,
                        filters: this.filters
                    });
                    
                    if (response.data && response.data.data) {
                        this.preciosParcelas = {
                            data: response.data.data,
                            meta: response.data.meta || {
                                current_page: 1,
                                per_page: 10,
                                total: response.data.data.length
                            }
                        };
                    } else {
                        this.$toast.error("Respuesta con formato inesperado:", response);
                    }
                } catch (error) {
                    this.$toast.error("Error al obtener ", error);
                } finally {
                    this.loading = false;
                }
            },
            
            showModal(modal) {
                this.$modal.show(modal);
            },
            
            closeModal(modal, actualizar) {
                this.$modal.hide(modal);
                if (actualizar) {
                    this.getParcelas();
                }
            },
            
            async eliminarParcela(id) {
                try {
                    this.loading = true;
                    await this.$store.dispatch('BACK_PRECIOS_PARCELAS_BORRAR', {
                        lista_id: this.listaId,
                        precio_id: id
                    });
                    this.$toast.success('Precio eliminado correctamente');
                    this.getParcelas();
                    this.closeModal('borrar-' + id, false);
                } catch (error) {
                    this.$toast.error('Error al eliminar: ' + (error.response?.data?.message || error.message));
                } finally {
                    this.loading = false;
                }
            },

            async cargarDatosParcela(id) {
                try {
                    this.cargando = true;
                    const response = await this.$store.dispatch('BACK_PRECIOS_PARCELAS_VER', {
                        lista_id: this.listaId,
                        precio_id: id
                    });
                    const parcela = response.data.data;
                    
                    this.parcelaEditando = {
                        ...parcela,
                        start_date: this.formatearFechaParaInput(parcela.start_date),
                        end_date: this.formatearFechaParaInput(parcela.end_date)
                    };
                    this.showModal('editar-' + id);
                } catch (error) {
                    this.$toast.error('Error al cargar datos: ' + error.message);
                    this.closeModal('editar-' + id, false);
                } finally {
                    this.cargando = false;
                }
            },
            
            async guardarCambios(parcela) {
                try {
                    this.guardando = true;
                    await this.$store.dispatch('BACK_PRECIOS_PARCELAS_EDITAR', {
                        lista_id: this.listaId,
                        precio_id: this.parcelaEditando.id,
                        precio: parcela.precio,
                        description: parcela.description,
                        start_date: this.formatearFechaParaAPI(parcela.start_date),
                        end_date: this.formatearFechaParaAPI(parcela.end_date),
                    });
                    this.$toast.success('Registro actualizada correctamente');
                    this.closeModal('editar-' + this.parcelaEditando.id, true);
                } catch (error) {
                    this.$toast.error('Error al actualizar: ' + error.message);
                } finally {
                    this.guardando = false;
                }
            },
            
            async crearParcela(parcela) {
                try {
                    this.creando = true;
                    await this.$store.dispatch('BACK_PRECIOS_PARCELAS_CREAR', {
                        lista_id: this.listaId,
                        precio: parcela.precio,
                        description: parcela.description,
                        start_date: this.formatearFechaParaAPI(parcela.start_date),
                        end_date: this.formatearFechaParaAPI(parcela.end_date)
                    });
                    this.$toast.success('Precio creado correctamente');
                    this.closeModal('crear-parcela', true);
                } catch (error) {
                    this.$toast.error('Error al crear precio: ' + (error.response?.data?.message || error.message));
                } finally {
                    this.creando = false;
                }
            },
            
            editarParcela(item) {
                this.parcelaEditando = { ...item };
                this.showModal('editar-' + item.id);
            },

            formatearFechaParaAPI(fechaStr) {
                if (!fechaStr) return '';
                
                const fecha = new Date(fechaStr);
                const dia = String(fecha.getDate()).padStart(2, '0');
                const mes = String(fecha.getMonth() + 1).padStart(2, '0');
                const anio = fecha.getFullYear();
                const hora = String(fecha.getHours()).padStart(2, '0');
                const minutos = String(fecha.getMinutes()).padStart(2, '0');
                
                return `${dia}-${mes}-${anio} ${hora}:${minutos}`;
            },

            formatearFechaParaInput(fechaStr) {
                if (!fechaStr) return '';

                const [datePart, timePart] = fechaStr.split(' ');
                const [day, month, year] = datePart.split('-');

                return `${year}-${month}-${day}T${timePart || '00:00'}`;
            },
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            },
            listaId() {
                return this.$store.getters.getListaId;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        }
    }
</script>